import { MaterialRequisitionItemFormResponse } from '@Types/api/form';

export const initialValuesForm: MaterialRequisitionItemFormResponse = {
  reqItemId: 0,
  requisitionId: 0,
  matId: null,
  matCode: '',
  actId: null,
  actCode: '',
  resId: 0,
  boqId: 0,
  unitName: '',
  unitId: 0,
  reqQty: 0,
  issuedQty: 0,
  specification: '',
  statusId: 0,
  approverNo: '',
  resCode: '',
  specId: null,
  compProjId: 0,
  storeId: 0,
  avlQty: 0,
  rate: 0,
  pettyCashQty: 0,
  transferQty: 0,
  transferRemarks: '',
  mtvId: 0,
  plantId: null,
  plantCode: '',
  ledgerId: null,
  ledgerCode: '',
  budgetCategoryId: 0,
  conReqId: 0,
  repeatForAll: false,
};
